import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';
import { AiOutlineDelete } from 'react-icons/ai';
import { useManajemenPengetahuanDaftarPesertaContext } from '../../../controller/admin/manajemen_pengetahuan/daftar-peserta';
import { useRole } from '../../../../hooks/useRole';

type ButtonModalDeletePesertaProps = {
  pesertaId: number;
  pesertaName: string;
  pengetahuanId: string;
};

/**
 * Renders a button that, when clicked, opens a modal dialog for confirming the deletion of a participant.
 *
 * @param {ButtonModalDeletePesertaProps} props - An object containing the participant ID, name, and knowledge ID.
 * @return {JSX.Element} A JSX element containing a button and an alert dialog.
 * @author Bagas Prasetyadi
 */

const ButtonModalDeletePeserta = ({
  pesertaId,
  pesertaName,
  pengetahuanId,
}: ButtonModalDeletePesertaProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef(null);

  const { deletePeserta } = useManajemenPengetahuanDaftarPesertaContext().dispatch;
  const { isLoadingDelete } = useManajemenPengetahuanDaftarPesertaContext().state;

  const { canMutate } = useRole();

  if (!canMutate) return null;

  return (
    <>
      <Button
        colorScheme="red"
        leftIcon={<AiOutlineDelete color="white" size={16} />}
        onClick={onOpen}
        isLoading={isLoadingDelete[pesertaId] || false}
      >
        Hapus Peserta
      </Button>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Konfirmasi Penghapusan
            </AlertDialogHeader>

            <AlertDialogBody>
              Apakah Anda yakin ingin menghapus peserta{' '}
              <strong>{pesertaName}</strong> dari pengetahuan ini?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Batal
              </Button>
              <Button
                colorScheme="red"
                onClick={() => {
                  deletePeserta(pesertaId, pengetahuanId);
                  onClose();
                }}
                ml={3}
                isLoading={isLoadingDelete[pesertaId] || false}
              >
                Yakin
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default ButtonModalDeletePeserta;
